import mockCategories from './mockCategories';

// Funktion zum Generieren von Gruppen basierend auf Kategorien
const generateMockGroups = () => {
  const groups = [];
  let groupId = 1;

  // Geschlechter
  const genders = ["männlich", "weiblich"];

  // Funktion zum Generieren eines Gruppennamens
  const generateGroupName = (category, ageGroup, gender) => {
    const genderText = gender === "männlich" ? "Männer" : "Frauen";
    return `${category} - ${ageGroup} - ${genderText}`;
  };

  // Funktion zum Generieren einer Gruppenbeschreibung
  const generateGroupDescription = (category, ageGroup, gender) => {
    const genderText = gender === "männlich" ? "männliche" : "weibliche";
    return `Wettkampfgruppe für ${genderText} Teilnehmer in der Kategorie ${category} der Altersgruppe ${ageGroup}`;
  };

  // Für jede Kategorie Gruppen erstellen
  mockCategories.forEach(category => {
    // Für jede Altersgruppe, in der die Kategorie verfügbar ist
    category.ageGroups.forEach(ageGroup => {
      // Für jedes Geschlecht eine Gruppe erstellen
      genders.forEach(gender => {
        const group = {
          id: groupId++,
          name: generateGroupName(category.name, ageGroup, gender),
          description: generateGroupDescription(category.name, ageGroup, gender),
          category: category.name,
          categoryId: category.id,
          categoryType: category.type,
          ageGroup: ageGroup,
          gender: gender,
          status: "Aktiv", // Standardstatus für alle Gruppen
          currentParticipants: 0, // Wird später basierend auf Teilnehmern berechnet
          startTime: null, // Wird später im Schedule gesetzt
          endTime: null, // Wird später im Schedule gesetzt
          venue: null, // Wird später gesetzt
          judges: [], // Wird später gesetzt
          results: [], // Wird später gesetzt
          isGroupPerformance: category.type === "Partnerform", // Partnerformen sind Gruppenperformances
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        };

        groups.push(group);
      });
    });
  });

  return groups;
};

// Funktion zum Aktualisieren der aktuellen Teilnehmeranzahl basierend auf mockParticipants
const updateParticipantCounts = (groups, participants) => {
  return groups.map(group => {
    const matchingParticipants = participants.filter(participant => 
      participant.ageGroup === group.ageGroup &&
      participant.gender === group.gender &&
      participant.category.includes(group.category)
    );

    return {
      ...group,
      currentParticipants: matchingParticipants.length
    };
  });
};

// Generiere die Gruppen
const mockGroups = generateMockGroups();

// Exportiere auch die Hilfsfunktion für die Aktualisierung der Teilnehmeranzahl
export const updateGroupParticipantCounts = (participants) => {
  return updateParticipantCounts(mockGroups, participants);
};

export default mockGroups; 